import { h } from "preact";
import './Banner.scss';

interface Props {
  children: JSX.Element | string | any;
  className?: string;
  icon?: string;
  color?: "info" | "warning" | "error" | "success";
  background?: "info" | "warning" | "error" | "success";
}

export default function Banner({
  children,
  className = "",
  icon = "info-circle",
  color = "info",
  background = "info",
}: Props) {
  return (
    <div
      className={`banner bg-${background}-50 border-${color}-600 flex gap-[20px] border-l-4 p-4 lg:p-8 ${className}`}
    >
      <i className={`fa fa-${icon} text-${color}-600 text-[18px]`} />
      <p className={`text-${color}-600 text-responsive`}>{children}</p>
    </div>
  );
}
